import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Dashbard from "../../Dashbard";
import { ArrowBackIos } from "@material-ui/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { AddUpdateFaqForm } from "./components/AddUpdateFaqForm";
import { useDispatch } from "react-redux";
import { faqsActions } from "../../../../../store/faq/faqActions";
import { toast } from "react-toastify";
import Loader from "../../../../../components/common/Loader";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Spinner } from "../../../../../components/common";
import { ExpandDownIcon } from "../../../LeftNav/SvgIcons";
import { productCategoriesActions } from "../../../../../store/product/productCategoriesAction";

const useStyles = makeStyles(theme => ({
  accordion: {
    borderRadius: "12px",
    "& .MuiAccordion-rounded:last-child": {
      borderBottomLeftRadius: "12px",
      borderBottomRightRadius: "12px",
    },
  },
  accordionSummary: {
    "& .MuiAccordionSummary-expandIcon.Mui-expanded": {
      transform: "rotate(90deg) !important",
    },
  },
}));

const initialValues = {
  id: 0,
  categoryId: 0,
  question: "",
  answer: "",
  priority: 1,
  platForm: [],
  subCategoryId: 0,
};

const NewFAQForm = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const { id: paramId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [values, setValues] = useState(initialValues);
  const [faqsCategoryData, setFaqsCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);

  // productCategoriesActions.onGetAllProductSubCategories(0)

  useEffect(() => {
    setLoading(true);
    dispatch(faqsActions.onGetFaqCategories()).then(data => {
      if (data?.data?.success) {
        setFaqsCategoryData(data?.data?.data);
      } else {
        setFaqsCategoryData([]);
      }
    });
    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);
    dispatch(productCategoriesActions.onGetAllProductSubCategories(0)).then(
      data => {
        setLoading(false);
        setSubCategoryData(data?.data);
      }
    );
  }, []);

  useEffect(() => {
    if (paramId) {
      setLoading(true);
      dispatch(faqsActions.onGetFaqById(paramId)).then(res => {
        if (res.success) {
          setValues(res?.data?.data);
        }
        setLoading(false);
      });
    }
  }, [paramId]);

  const handleSubmit = values => {
    setLoading(true);
    dispatch(faqsActions.onAddUpdateFaq(values)).then(res => {
      if (res?.success) {
        history.push("/support-faq");
      } else {
        toast.error("Something went wrong!");
      }
      setLoading(false);
    });
  };

  return (
    <Dashbard>
      <div className='body-content'>
        {isLoading ? <Spinner /> : null}
        <div className='contentHeading '>
          <h1>{!paramId ? "New" : "Edit"} FAQ</h1>
        </div>
        <span className='consumerHeading'>
          <Button
            color='primary'
            onClick={() => history.goBack()}
            variant='contained'>
            <ArrowBackIos /> Back to All FAQs
          </Button>
        </span>
        <Accordion
          className={`gridBody contentBody ${classes.accordion}`}
          defaultExpanded={true}>
          <AccordionSummary
            expandIcon={<ExpandDownIcon />}
            className={classes.accordionSummary}
            aria-controls='panel1a-content'
            id='panel1a-header'>
            <Grid>
              <h1>FAQs Info</h1>
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <AddUpdateFaqForm
              handleSubmit={handleSubmit}
              values={values}
              setValues={setValues}
              faqsCategoryData={faqsCategoryData}
              subCategoryData={subCategoryData}
            />
          </AccordionDetails>
        </Accordion>
      </div>
    </Dashbard>
  );
};

export default NewFAQForm;
